import { render, staticRenderFns } from "./AddAndEdit.vue?vue&type=template&id=753ed1a4&"
import script from "./AddAndEdit.vue?vue&type=script&lang=js&"
export * from "./AddAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddAndEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports